// extracted by mini-css-extract-plugin
export default {"TeamMembersContainer":"TeamCarousel_TeamMembersContainer__4l0Rp","TeamMemberCards":"TeamCarousel_TeamMemberCards__FtYQE","leadership":"TeamCarousel_leadership__yoJ18"};